module.exports = __webpack_public_path__ + "img/shoplogo.f7be3d28.svg";